export class ElementSelectOptionModel {
    value: string | boolean | number;
    viewValue: string;
}
